<template>
  <ConfigLayout current="coursemenu">
    <ConfigPage title="コース設定">
      <template slot="header">
        <Button flat :disabled="!allCourses.length" @click="$router.push({ name: 'coursemenuOrder' })">
          <MoveIcon />並べ替え
        </Button>
        <Separator />
        <Button flat @click="showEdit"><AddStrongIcon />新規</Button>
      </template>
      <SearchBar v-model="inputFilter" placeholder="コース名" @search="() => (filter = inputFilter)" />
      <DataTable
        class="courses"
        :data="courses"
        :columns="[
          { key: 'name', name: 'コース名' },
          { key: 'price', name: '金額' },
        ]"
        :minItemHeight="56"
        :loading="busy"
        nodata="該当データが存在しません"
        editButton
        @edit="showEdit"
        deleteButton
        @delete="onDelete"
      >
        <template #name="{ item }">{{ item.names.jpn }}</template>
        <template #price="{ item }"> {{ numberFormat(item.price) }}円 </template>
      </DataTable>
      <CourseEditModal v-if="courseEditModal" @saved="fetch" @close="courseEditModal = false" />
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { orderBy } from 'lodash'
import { numberFormat } from '@/utils/number'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import Button from '@/components/atoms/Button'
import { Separator } from '@/components/molecules/PageHeader'
import SearchBar from '@/components/molecules/SearchBar'
import DataTable from '@/components/molecules/DataTable'
import Dialog from '@/components/molecules/ModalDialog'
import CourseEditModal from '@/components/organisms/CourseEditModal'
import AddStrongIcon from '@/components/icons/addStrong'
import MoveIcon from '@/components/icons/move'

export default {
  name: 'Options',
  components: {
    ConfigLayout,
    ConfigPage,
    Button,
    Separator,
    SearchBar,
    DataTable,
    CourseEditModal,
    AddStrongIcon,
    MoveIcon,
  },
  data() {
    return {
      courseEditModal: false,
      inputFilter: '',
      filter: '',
    }
  },
  computed: {
    ...mapState({
      busy: state => state.courses.busy,
    }),
    ...mapGetters({
      allCourses: 'courses/all',
    }),
    courses() {
      return orderBy(this.allCourses.filter(course => course.names.jpn.includes(this.filter)))
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    numberFormat,
    async fetch() {
      await this.$store.dispatch('courses/get')
    },
    async onDelete({ id, names }) {
      if (
        (await Dialog.confirm({
          title: 'コース削除',
          message:
            '以下のコース登録を削除してよろしいですか？\n削除すると分析画面の該当のコースが削除されます\n予約情報内のコース表示は維持されます',
          target: names.jpn,
          caution: true,
          cancelText: '戻る',
          okText: '削除',
        })) &&
        (await this.$store.dispatch('courses/delete', id))
      ) {
        this.fetch()
      }
    },
    showEdit({ id } = {}) {
      this.$store.dispatch('courses/edit/start', id)
      this.courseEditModal = true
    },
  },
}
</script>

<style lang="postcss" scoped>
.courses {
  >>> .name {
    padding: 8px 24px;
  }
  >>> .price {
    min-width: 126px;
    white-space: initial;
    width: 126px;
  }

  >>> td.price {
    justify-content: right;
  }
}
</style>
